/*	Copyright (c) 1996 - 2026 NoWatt Ltd				*/
/*	  All Rights Reserved  											*/

import React, { useEffect } from 'react';

const Technology = () => {
  useEffect(() => {
    const fancybox = window.Fancybox;
    if (fancybox?.bind) fancybox.bind('[data-fancybox]');
  }, []);

  return (
    <div id="tf-clients" className="text-center">
      <div className="overlay">
        <div className="container">
          <div className="section-title center">
            <h2><strong>Our Technology</strong></h2>
            <div className="line"><hr /></div>
          </div>
          <div className="row">
            <div className="col-12 col-md-4">
              <a data-fancybox="youtube" href="https://www.youtube.com/watch?v=-_OK3D_jeZk">
                <img src="img/v5investigate.jpg" alt="Data Investigation" />
                <p className="intro">Data Investigation</p>
              </a>
            </div>
            <div className="col-12 col-md-4">
              <a data-fancybox="youtube" href="https://www.youtube.com/watch?v=EamcdM0HmH8">
                <img src="img/v5analysis.jpg" alt="Artificial Intelligence" />
                <p className="intro">Artificial Intelligence</p>
              </a>
            </div>
            <div className="col-12 col-md-4">
              <a data-fancybox="youtube" href="#">
                <img src="img/v5inside.jpg" alt="NoWatt Inside" />
                <p className="intro">NoWatt Inside</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Technology;
